import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EnhancedButton from 'material-ui/internal/EnhancedButton';
import { FormattedMessage } from 'react-intl';

import makeClassMapper from 'lib/makeClassMapper';

import classes from './ActionButton.less';

const mapClasses = makeClassMapper(classes);

class ActionButton extends Component {
  render() {
    const {
      localeId,
      localeValues = {},
      style = {},
      align,
      onClick,
      staticValue,
      propagate = false,
      ...other
    } = this.props;
    return (
      <div className={mapClasses(['wrapper', align])}>
        <EnhancedButton
          onClick={e => {
            e.preventDefault();
            if (!propagate) e.stopPropagation();
            onClick(e);
          }}
        >
          <div style={style} className={mapClasses(['button', ...Object.keys(other)])}>
            {!localeId && staticValue ? staticValue : <FormattedMessage id={localeId} values={localeValues} />}
          </div>
        </EnhancedButton>
      </div>
    );
  }
}

ActionButton.propTypes = {
  localeId: PropTypes.string,
  localeValues: PropTypes.object,
  style: PropTypes.object,
  align: PropTypes.string,
  onClick: PropTypes.func,
  staticValue: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  propagate: PropTypes.bool,
};

export default ActionButton;
